import { getFlavorGroupsByCategory } from 'utils/api/flavors.api';
import { useQuery } from 'react-query';

async function queryFn({ queryKey }) {
    const { category, country, dataSource, order_by, ascending } = queryKey[1];
    const groups = await getFlavorGroupsByCategory({
        category,
        country,
        dataSource,
        order_by,
        ascending,
    });
    const groupsByName = {};
    const topGroups = [];
    const unseen = groups.data;
    while (unseen.length) {
        const group = unseen.shift();
        if (!group.parentName) {
            groupsByName[group.name] = {
                ...group,
                children: [],
            };
            continue;
        }
        group.textId = [group.parentName, group.name].join('||');
        if (topGroups.length < 6) {
            topGroups.push(group);
        }
        if (groupsByName[group.parentName]) {
            groupsByName[group.parentName].children.push(group);
        } else {
            throw new Error(
                `Parent group ${group.parentName} not found for group ${group.name}`,
            );
        }
    }
    return {
        groupsByName,
        topGroups,
    };
}

function useFlavorGroups({
    category,
    country,
    dataSource,
    order_by,
    ascending,
}) {
    return useQuery({
        queryKey: [
            'flavor-groups',
            {
                category: category ? [category] : null,
                country: country ? [country] : null,
                dataSource,
                order_by,
                ascending,
            },
        ],
        queryFn,
        enabled: Boolean(category && country && dataSource && order_by),
    });
}

export default useFlavorGroups;
